export const KNOWN_TIMEFRAMES = ['TH', 'HI', 'LO', 'EX']